import React, { useEffect, useState } from "react";
import "../style.scss";
import SideNav from "components/SideNav";
import { getAuth, signOut } from "firebase/auth";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../components/ui/card.tsx";

export default function Main() {
  useEffect(() => {
    //logout

    const logoutUser = document.querySelector(".btn-logout");
    const logoutUserFooter = document.querySelector(".btn-logout-footer");

    logoutUser.addEventListener("click", () => {
      logout();
    });

    logoutUserFooter.addEventListener("click", () => {
      logout();
    });

    function logout() {
      const auth = getAuth();

      signOut(auth)
        .then(() => {
          window.location.replace("/");
        })
        .catch((error) => {
          alert("Fehler: " + error);
        });
    }
  }, []);

  const Content = () => (
    <section className="home-section">
      <div className="text">Willkommen</div>

      <Card>
        <CardHeader>
          <CardTitle>Card Title</CardTitle>
          <CardDescription>Card Description</CardDescription>
        </CardHeader>
        <CardContent>
          <p>Card Content</p>
        </CardContent>
        <CardFooter>
          <p>Card Footer</p>
        </CardFooter>
      </Card>

      {/* <section className="hero" id="hero">
        <div className="text">Gruppe erstellen</div>
      </section> */}
    </section>
  );

  const selPage = "dashboard";

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      <SideNav Content={Content} selPage={selPage}></SideNav>
    </>
  );
}
